import styled from 'styled-components';

import { Container } from '@components/global';

export const Nav = styled.nav`
  position: fixed;
  width: 100%;
  // TODO: lift state up and use to determine the padding with a ternary
  padding: ${props => props.scrollState ? '0' : '50px 0'};
  // padding: 50px 0;
  z-index: 100;
  font-family: ${props => props.theme.font.link};

  // Animates navbar on scroll
  transition: 0.8s cubic-bezier(0.2, 0.8, 0.2, 1.0);

  .pageScrolled {
    background: rgba(255, 255, 255, .8);
    padding: 15px 0;
    backdrop-filter: blur(20px);
  }

  @media (max-width: ${props => props.theme.screen.md}) {
    background: rgba(255, 255, 255, .8);
    backdrop-filter: blur(20px);

    .pageScrolled {
      background: transparent;
      backdrop-filter: blur(0px);
    }

    img.mobile {
      width: 95px;
    }
  }
`;

export const StyledContainer = styled(Container)`
  max-width: 1140px;
  margin: 0 auto;
  text-align: center;
  display: grid;
  grid-template-columns: repeat(4, auto);
  align-items: center;
  justify-items: center;
  border-bottom: 1;
  font-family: ${props => props.theme.font.link};

  a {
    color: ${props => props.theme.color.black.full};
  }

  a:hover {
    color: ${props => props.theme.color.purple.regular};
  }

  img {
    transition: 0.4s cubic-bezier(0.2, 0.8, 0.2, 1.0);
  }
`;

export const NavListWrapper = styled.div`
  ul {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: row;

    ${({ mobile }) =>
      mobile &&
      `
        flex-direction: column;
        margin-top: 1em;

        > ${NavItem} {
          margin: 0;
          margin-top: 0.75em;
        }
      `};
  }
`;

export const NavItem = styled.li`
  margin: 0 0.75em;
  font-family: ${props => props.theme.font.link};
  ${props => props.theme.font_size.small};

  a {
    text-decoration: none;
    opacity: 0.7;
    color: ${props => props.theme.color.black.regular};
  }

  &.active {
    a {
      opacity: 1;
    }
  }
`;

export const MobileMenu = styled.div`
  width: 100%;
  padding: 0 50px;
  background: ${props => props.theme.color.white.regular};

  a:hover {
    color: ${props => props.theme.color.purple.regular};
  }
`;

export const Brand = styled.div`
  font-family: ${props => props.theme.font.primary};
  ${props => props.theme.font_size.large};
`;

export const Mobile = styled.div`
  display: none;
  grid-column: 3 / span 2;

  @media (max-width: ${props => props.theme.screen.md}) {
    display: block;
  }

  ${props =>
    props.hide &&
    `
    display: block;

    @media (max-width: ${props.theme.screen.md}) {
      display: none;
    }
  `}
`;
